<template>
<div>
    
   <h1>Contact Page</h1>
    
</div>
</template>

<script>

// import {Helper} from "../../helpers";

// import {HTTP} from '../../utils/HTTP';
export default {
    name: "ClientProfileContact",
    components: {
       
    },
    data() {
        return {
            clientId:null
                   
        }
    },

computed: {

    },
    methods: {
    
    },
    mounted(){
       this.clientId = this.$route.params.id; 
    }
}
</script>

<style scoped>

</style>
